// extracted by mini-css-extract-plugin
export default {"Wrapper":"Wrapper_Wrapper__4Uz1O","Wrapper_Top":"Wrapper_Wrapper_Top__ThwVl","Wrapper_Column":"Wrapper_Wrapper_Column__mBu4T"};